module.exports = __webpack_public_path__ + "static/media/kv-th.b5c07de7.png";